import type { Record } from "@suse-o11y/record";

import type { FullStackPack, NodeId, StackPack, StackPackConfiguration, UnlockedStrategy } from "~/models/dto";

import { request } from "../generic/request";

export const getStackPacks = (): Promise<Array<FullStackPack>> => request("/api/stackpack");

export const provision = (stackPack: StackPack, data: Record<string, string>): Promise<StackPackConfiguration> =>
	request<StackPackConfiguration>(`/api/stackpack/${stackPack.name}/provision`, {
		method: "POST",
		body: data,
	});

export const retryProvision = (
	stackPackName: string,
	configurationId: NodeId,
	flag: UnlockedStrategy,
): Promise<StackPackConfiguration> =>
	request(`/api/stackpack/${stackPackName}/provision/${configurationId}`, {
		method: "POST",
		query: {
			unlocked: flag as string,
		},
	});

export const deprovision = (stackPack: StackPack, configId: NodeId, retry = false): Promise<any> =>
	request<StackPackConfiguration>(`/api/stackpack/${stackPack.name}/deprovision/${configId}`, {
		method: "POST",
		query: {
			unlocked: retry ? "overwrite" : undefined,
		},
	});

export const upgrade = (stackPack: string, flag?: UnlockedStrategy): Promise<void> =>
	request<void>(`/api/stackpack/${stackPack}/upgrade`, {
		method: "POST",
		query: {
			unlocked: (flag as string) ?? "fail",
		},
	});
